import axios from 'axios';
import {ENDPOINT_URL, GET_USERS_LIST} from '../../../constants/commonConstants';
import {decodeAgentResponse} from '../../core/resolutionUtils';

/**
 * Build the users list URL for a given page/search.
 * @param {number} limit page size
 * @param {number} offset page offset
 * @param {string} [search] optional search term
 * @return {string} request URL
 */
function buildUsersUrl(limit, offset, search) {
	let url = `${ENDPOINT_URL}${GET_USERS_LIST}?limit=${limit}&offset=${offset}`;
	if (search) url += `&search=${encodeURIComponent(search)}`;
	return url;
}

/**
 * Active/inactive user counts.
 *
 * The users API has no is_active filter, so a total can't come from a
 * single filtered count the way it can for e.g. access point status. The
 * total is probed with a 1-row request first (cheap, gives an exact
 * `count`), then that exact count is requested in one follow-up call and
 * tallied client-side from each row's boolean `status` field - the same
 * field users.jsx already reads to render Active/Inactive.
 * @param {object} command semantic statistic command
 * @return {Promise<{values: {total: number, active: number, inactive: number}}>} counts
 */
export async function readUserStatusCounts(command = {}) {
	const search = command.params?.query;
	const {data: probeData} = await axios.get(buildUsersUrl(1, 0, search));
	const total = Number(decodeAgentResponse(probeData)?.count) || 0;
	if (total === 0) {
		return {values: {total: 0, active: 0, inactive: 0}};
	}
	const {data} = await axios.get(buildUsersUrl(total, 0, search));
	const rows = decodeAgentResponse(data)?.results;
	const active = Array.isArray(rows) ? rows.filter((row) => !!row?.status).length : 0;
	return {values: {total, active, inactive: total - active}};
}
